import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section
      className="h-[100vh] flex flex-col justify-center items-start relative px-8 md:px-24 overflow-hidden bg-fixed"
      style={{
        backgroundImage: "url('/img/logo.png')", // ✅ Path from public/img/
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundAttachment: "fixed", // ✅ Keeps background fixed
      }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/50"></div>

      {/* Hero Content */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        className="relative z-10 max-w-2xl text-left"
      >
        <p className="text-white text-xl mb-3 font-medium tracking-wide uppercase">
          Welcome to
        </p>

        <h1 className="text-5xl md:text-6xl font-extrabold text-white mb-5 leading-tight drop-shadow-lg">
          Torshia <span className="text-[#B80000]">Traders</span>
        </h1>

        <p className="text-lg md:text-xl text-gray-100 mb-10 leading-relaxed">
          Importers & Suppliers of Research Equipment, Laboratory Chemicals,
          Solvents, Adhesives, and Industrial Materials.
        </p>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">
          <button
            onClick={() => navigate("/about")}
            className="px-10 py-3 bg-[#B80000] text-white rounded-full font-semibold shadow-lg hover:bg-[#990000] transition-all duration-300"
          >
            Know More
          </button>
          <button
            onClick={() => navigate("/contact")}
            className="px-10 py-3 bg-white text-[#B80000] rounded-full font-semibold shadow-lg hover:bg-gray-100 transition-all duration-300"
          >
            Get Free Consultant
          </button>
        </div>
      </motion.div>
    </section>
  );
}
